import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Spin, Table } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PromotionApi from '../../functions/api/booking/PromotionApi';
import MyUtil from '../../functions/MyUtil';
import ButtonActive from './ButtonActive';
import ButtonFormatter from './ButtonFormatter';
import ButtonShow from './ButtonShow';

class ListPromotion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listPromotions: [],
      redirectAdd: false,
      list: [],
    };
  }

  activeFormatter = (cell, row) => {
    return (
      <ButtonFormatter
        cell={cell}
        row={row}
        onChangeList={this.handleChangeList}
        list={this.state.listPromotions}
      />
    );
  };

  timeAppliedFormatter = (cell, row) => {
    const dateActive = row.promo_active;
    const dateExpire = row.promo_expire;

    return (
      <span>{`${moment(dateActive).format('DD/MM/YYYY')} - ${moment(
        dateExpire
      ).format('DD/MM/YYYY')}`}</span>
    );
  };

  discountValueFormatter = (cell, row) => {
    return (
      <span>
        {cell <= 100 ? `${cell} %` : `${MyUtil.currencyFormat(cell)} vnđ`}
      </span>
    );
  };

  promoCodeFormatter = (cell, row) => {
    return <span>{cell.toUpperCase()}</span>;
  };

  vehicleModelFormatter = (cell, row) => {
    return <span>{cell ? MyUtil.makeTitle(cell) : 'Tất cả'}</span>;
  };

  vehiclePartnerFormatter = (cell, row) => {
    return <span>{cell ? cell : 'Tất cả'}</span>;
  };

  partnerFormatter = (cell, row) => {
    return <span>{cell ? cell : 'Tất cả'}</span>;
  };

  async componentDidMount() {
    var listPromotions = await PromotionApi.getAll();
    if (listPromotions) this.setState({ listPromotions: listPromotions });
  }
  handleInsertButtonClick = () => {
    this.setState({ redirectAdd: true });
  };

  handleChangeList = (list) => {
    this.setState({ listPromotions: list });
  };

  buttonShow = (cell, row) => {
    return <ButtonShow cell={cell} row={row} />;
  };

  buttonActive = (cell, row) => {
    return <ButtonActive cell={cell} row={row} />;
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={clearFilters} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
  });

  render() {
    const { listPromotions, redirectAdd } = this.state;

    if (listPromotions.length === 0) {
      return <Spin />;
    }
    // const canAdd = MyUtil.hasPermission(this.props.match_parent.url, 'add');

    if (redirectAdd) {
      return (
        <Redirect push to={`${this.props.match_parent.url}/add-promotion`} />
      );
    }

    const columnPromos = [
      {
        title: 'ID',
        dataIndex: 'promo_id',
        key: 'promo_id',
        fixed: 'left',
      },
      {
        title: 'Code',
        dataIndex: 'promo_code',
        key: 'promo_code',
        fixed: 'left',
        render: this.promoCodeFormatter,
        ...this.getColumnSearchProps('promo_code'),
      },
      {
        title: 'Giá trị giảm',
        dataIndex: 'promo_val',
        key: 'promo_val',
        fixed: 'left',
        render: this.discountValueFormatter,
      },
      {
        title: 'Dòng xe',
        dataIndex: 'vhc_slug',
        key: 'vhc_slug',
        render: this.vehicleModelFormatter,
        ...this.getColumnSearchProps('vhc_slug'),
      },
      {
        title: 'Đối tác',
        dataIndex: 'part_name',
        key: 'part_name',
        render: this.partnerFormatter,
      },
      {
        title: 'Xe của đối tác',
        dataIndex: 'vhc_part_name',
        key: 'vhc_part_name',
        render: this.vehiclePartnerFormatter,
      },
      {
        title: 'Thời gian áp dụng',
        render: this.timeAppliedFormatter,
      },
      {
        title: 'Active',
        render: this.buttonActive,
      },
      {
        title: 'Show',
        render: this.buttonShow,
      },
      {
        title: ' Chỉnh sửa',
        render: this.activeFormatter,
      },
    ];

    return (
      <div className="content">
        <Space>
          {MyUtil.hasPermission('/promotion', 'add') && (
            <Button onClick={this.handleInsertButtonClick} type="primary">
              Thêm
            </Button>
          )}
        </Space>
        <Table
          rowKey="promo_id"
          size="small"
          columns={columnPromos}
          dataSource={listPromotions}
          scroll={{ x: 'max-content' }}
        />
      </div>
    );
  }
}

export default ListPromotion;
